/**
 * @name parseQueryFilters
 * @desc Parse query filters to API suitable format.
 * @param {array} filters
 * @return object
 */
export default function parseQueryFilters(filters) {
    return filters.reduce((filters, item, index) => {
        filters["filter["+index+"][column]"] = item.column;
        filters["filter["+index+"][condition]"] = item.condition;
        filters["filter["+index+"][values]"] = item.values;
        return filters;
    }, {});
}